<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row>
    <v-col class="text-right">
      <v-dialog v-model="modifiersDialog" scrollable max-width="677px">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
                  dark
                  v-bind="attrs"
                  v-on="on"
          >
            Редактировать
          </v-btn>
        </template>
        <v-card>
          <v-card-title>Редактировать ингредиенты</v-card-title>
          <v-card-text>
            <v-expansion-panels>
              <v-expansion-panel
                      v-for="modifierCategory in modifierCategories"
                      :key="modifierCategory.id"
                      :id="modifierCategory.id"
              >
                <v-expansion-panel-header>{{modifierCategory.name}}</v-expansion-panel-header>
                <v-expansion-panel-content class="without-padding">
                  <ul class="product-category-modifiers">
                    <li v-for="modifier in modifierCategory.modifiers" :class="{selected: modifier.selected}" v-if="!isExist(modifier)">
                      <v-simple-checkbox
                              v-model="modifier.selected"
                      >
                      </v-simple-checkbox>
                      <div class="name">{{ modifier.name }}</div>
                    </li>
                  </ul>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-card-text>
          <v-card-actions>
            <v-btn block @click="addProductsToConstructor" :loading="loadingButton">Сохранить</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
    <v-col cols="12" style="height: 60px;">
      <template v-if="selected.length > 0">
        <v-btn class="mr-3" :disabled="selected.length === 0" outlined>Выбрано: {{ selected.length }}</v-btn>
        <v-menu offset-y left :disabled="selected.length === 0">
          <template v-slot:activator="{ on, attrs }">
            <v-btn outlined
                   :disabled="selected.length === 0"
                   class="pl-0 pr-0"
                   min-width="36"
                   v-bind="attrs"
                   v-on="on">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="submitDialog = true; submitItem = null">
              <v-list-item-title>Удалить</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </v-col>
    <v-col cols="12">
      <v-data-table
              no-data-text="Нету ингрендиентов"
              no-results-text="По заданному запросу ничего не найдено"
              v-model="selected"
              :headers="headers"
              :items="modifiers"
              :search="search"
              :header-props="{sortIcon: 'icon-custom-arrow'}"
              :fixed-header="true"
              height="60vh"
              :options.sync="options"
              :footer-props="footerProps"
              :server-items-length="totalProducts"
              :loading="loading"
              :items-per-page="15"
              loading-text="Загрузка ингредиентов... Подождите пожалуйста"
              show-select
      >
        <template v-slot:item.price="{ item, index }">
          <v-text-field outlined
                        v-model="item.price"
                        dense
                        width="100"
                        hide-details
                        style="width: 90px"
                        @change="updatePrice(item)"
                        suffix="UAH">
          </v-text-field>
        </template>
        <template v-slot:item.required="{item, index}">
          <v-simple-checkbox @click="toggleRequired(item)" v-model="item.required"></v-simple-checkbox>
        </template>
        <template v-slot:item.image="{ item, index }">
          <template v-if="item.modifier.image">
            <v-img :src="item.modifier.image.url" :width="40" :height="32"></v-img>
          </template>
        </template>
<!--        <template v-slot:header.modifier.category.name>-->
<!--          Категория<br>-->
<!--          <v-btn color="secondary" fab x-small outlined-->
<!--                 @click.stop.prevent="filters.category.modal = !filters.category.modal; overlay = !overlay">-->
<!--            <v-icon>mdi-filter-variant</v-icon>-->
<!--          </v-btn>-->
<!--          <v-card :ripple="false" class="filter-popup" v-if="filters.category.modal" @click.stop>-->
<!--            <v-card-text>-->
<!--              <v-select-->
<!--                      :items="categories"-->
<!--                      :item-text="category => category.name"-->
<!--                      :item-value="category => category.id"-->
<!--                      v-model="filters.category.tempValue"-->
<!--                      label="Категории"-->
<!--                      :clearable="true"-->
<!--                      outlined-->
<!--                      multiple-->
<!--                      :hide-details="true"-->
<!--              >-->
<!--                <template v-slot:selection="{ item, index }">-->
<!--                  <span v-if="index === 0" class="font-weight-bold">-->
<!--                    Выбрано: {{ filters.category.tempValue.length }}-->
<!--                  </span>-->
<!--                </template>-->
<!--              </v-select>-->
<!--              <div class="text-right mt-3">-->
<!--                <v-btn @click.prevent.stop="setCategoryFilter" color="secondary">Выбрать</v-btn>-->
<!--              </div>-->
<!--            </v-card-text>-->

<!--          </v-card>-->
<!--        </template>-->
        <template v-slot:item.actions="{ item }">
          <v-menu offset-y left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                      small
                      class="mr-2"
                      v-bind="attrs"
                      v-on="on"
              >
                mdi-dots-vertical
              </v-icon>
            </template>
            <v-list>
              <v-list-item @click="submitDialog = true; submitItem = item">
                <v-list-item-title>Удалить</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </v-data-table>
    </v-col>
    <v-dialog
            v-model="submitDialog"
            max-width="444"
    >
      <v-card>
        <v-card-title >
          Подтвердить действие
        </v-card-title>

        <v-card-actions>

          <v-btn
                  v-if="submitItem == null"
                  @click="submitDelete(submitItem); submitDialog = false">
            Да
          </v-btn>
          <v-btn
                  v-else
                  @click="submitDelete(submitItem); submitDialog = false">
            Да
          </v-btn>
          <v-btn
                  outlined
                  @click="submitDialog = false"
          >
            Нет
          </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  import ModifierService from "../api/ModifierService";
  import ProductService from "../api/ProductService";
  import CategoryService from "../api/CategoryService";

  export default {
    name: 'ConstructorModifiersTable',
    props: {
    },
    data: () => ({
      modifiersDialog: false,
      selected: [],
      submitDialog: false,
      loadingButton: false,
      submitItem: null,
      filters: {
        category: {
          value: [],
          tempValue: [],
          modal: false,
        },
      },
      overlay: false,
      search: '',
      loading: true,
      categories: [],
      options: {},
      footerProps: {
        itemsPerPageText: 'Ингредиентов на страницу',
        pageText: '{0}-{1} из {2}',
        itemsPerPageAllText: 'Все',
        itemsPerPageOptions: [15, 30, -1]
      },
      totalProducts: 0,
      headers: [
        {
          text: 'Ингредиент',
          value: 'modifier.name',
        },
        {text: 'Категория', value: 'modifier.category.name'},
        {
          text: 'Изображение',
          value: 'image',
          sortable: false
        },
        {
          text: 'Нельзя удалить',
          value: 'required',
          sortable: false
        },
        {
          text: 'Цена',
          value: 'price',
          sortable: false},
        {text: 'Действия', value: 'actions', sortable: false, width: "5%"},
      ],
      modifiers: [],
      modifierCategories: []
    }),
    mounted() {
      ModifierService.getCategoryList().then(response => {
        this.categories = response.data
      });
      ModifierService.listByCategory().then(response => {
        this.modifierCategories = response.data
      });
    },
    watch: {
      options: {
        handler() {
          this.getDataFromApi()
        },
        deep: true,
      },
      "filters.category.value": {
        handler() {
          this.getDataFromApi()
        },
        deep: true,
      },
      search() {
        this.getDataFromApi()
      }
    },
    methods: {
      submitDelete(item = null){
        if(item){
          this.removeFromConstructor(item)
        } else {
          this.massDelete()
        }
      },
      toggleRequired(item){
        CategoryService.updateModifierRelation(item.id, {
          required: item.required ? 1 : 0
        })
      },
      massDelete(){
        let params = {
          ids: this.collectSelectedId()
        };

        let _this = this;

        this.selected.forEach(function (value) {
          _this.removeFromConstructor(value)
        })
      },
      collectSelectedId(){
        let ids = [];
        this.selected.forEach(function (item) {
          ids.push(item.id)
        })

        return ids;
      },
      isExist(item){
        if(this.modifiers.find(modifier => modifier.modifier.id === item.id)){
          return true
        }
        return false
      },
      addProductsToConstructor(){
        this.loadingButton = true
        let ids = [];
        this.modifierCategories.forEach(function (category) {
          category.modifiers.forEach(function (modifier) {
            if(modifier.selected){
              ids.push(modifier.id)
            }
          })

        })

        ModifierService.addToConstructor(ids).then(response => {
          this.getDataFromApi()
          this.modifiersDialog = false;
          this.loadingButton = false
        })
      },
      removeFromConstructor(item){
        this.loading = true;
        ModifierService.removeFromConstructor(item.id).then(response => {
            this.getDataFromApi()
        })
      },
      updatePrice(item){
        ModifierService.updateConstructor(item.id, {price: item.price})
      },
      setCategoryFilter(e) {
        this.filters.category.value = this.filters.category.tempValue
        this.filters.category.modal = false;
        this.overlay = false;
      },
      getDataFromApi() {
        this.loading = true

        let params = {
          page: this.options.page,
          perPage: this.options.itemsPerPage,
          sortBy: this.options.sortBy.length > 0 ? this.options.sortBy[0] : '',
          sortDesc: this.options.sortBy.length > 0 ? this.options.sortDesc[0] : '',
          search: this.search,
          categories: this.filters.category.value,
        }
        ModifierService.listConstructor(params)
          .then(response => {
            this.modifiers = response.data.data
            this.totalProducts = response.data.total
            this.loading = false
          })
      },
    }
  }
</script>

<style lang="scss">
  ul{
    &.product-category-modifiers{
      list-style-type: none;
      padding-left: 24px!important;
      li{
        list-style-type: none;
        display: grid;
        grid-template-columns: 42px 1fr;
        margin-bottom: 8px;
        .v-simple-checkbox{
          text-align: center;
        }
        &.selected{
          background-color: #EEF8FF;
        }
        .name{
          line-height: 40px;
          color: #666;
          font-weight: 500;
          padding-left: 8px;
          font-size: 14px;
        }
      }
    }
  }
  .filter-popup {
    position: absolute;
    width: 250px;
    z-index: 5;

    &:hover {
      cursor: auto;
    }



    &.v-card--link:focus::before {
      opacity: 0;
    }
  }


</style>
